/* eslint react/prop-types: 0 */
import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { checkImagePromise } from '../../../../shared/helpers/WVUtilities';
// import TrinityCheck from './TrinityCheck';

export default React.memo((props) => {
  const { deal } = props;
  const creator = deal.creator || {};
  const [image, setImage] = useState('/images/user/defaultAvatar.png');
  
  // Get thumbnail from mediaChannels
  const youtubeChannel = creator.mediaChannels?.find(c => c.accountType === 'youtube');
  const instagramChannel = creator.mediaChannels?.find(c => c.accountType === 'instagram');
  const facebookChannel = creator.mediaChannels?.find(c => c.accountType === 'facebook');
  const twitterChannel = creator.mediaChannels?.find(c => c.accountType === 'twitter');
  
  const creatorName = creator.title || 'Unknown Creator';

  useEffect(() => {
    let isMounted = true;

    const loadImage = async () => {
      if (isMounted) {
        setImage('/images/user/defaultAvatar.png');
      }

      if (youtubeChannel?.thumbnailUrl && await checkImagePromise(youtubeChannel.thumbnailUrl)) {
        if (isMounted) setImage(youtubeChannel.thumbnailUrl);
      } else if (instagramChannel?.thumbnailUrl && await checkImagePromise(instagramChannel.thumbnailUrl)) {
        if (isMounted) setImage(instagramChannel.thumbnailUrl);
      } else if (facebookChannel?.thumbnailUrl && await checkImagePromise(facebookChannel.thumbnailUrl)) {
        if (isMounted) setImage(facebookChannel.thumbnailUrl);
      } else if (twitterChannel?.thumbnailUrl && await checkImagePromise(twitterChannel.thumbnailUrl)) {
        if (isMounted) setImage(twitterChannel.thumbnailUrl);
      }
    };

    loadImage();

    return () => {
      isMounted = false;
    };
  }, [creator.id]);

  return (
    <div
      className="d-flex"
      style={{ minWidth: '250px' }}
    >
      <img
        src={image}
        alt={creatorName}
        style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '4px' }}
        className="align-self-center"
      />
      <div
        className="align-self-center flex-column"
        style={{ marginLeft: '8px' }}
      >
        <div className="">
          {creator.id ? (
            <a
              href={`/creator/${creator.id}`}
              className="bold-text"
            >
              {creatorName}
            </a>
          ) : (
            <span className="bold-text">{creatorName}</span>
          )}
        </div>
        <div className="">
          {creator.mediaChannels?.map(channel => (
            channel.url ? (
              <a
                href={channel.url}
                target="_blank"
                rel="noreferrer"
                key={channel.accountType}
                style={{ marginRight: '4px' }}
                title={channel.channelName}
              >
                <img
                  src={`/images/mediacontent/${channel.accountType}.png`}
                  alt={channel.accountType}
                  style={{ width: '20px' }}
                />
              </a>
            ) : null
          ))}
          {/* Trinity Safety Check no longer relevant
          {deal.prospectId && (
            <TrinityCheck deal={deal} onUpdate={onUpdate} />
          )}
          */}
        </div>
      </div>
    </div>
  );
}, (a, a1) => _.isEqual(a.deal?.creator, a1.deal?.creator) && _.isEqual(a.deal?.prospect, a1.deal?.prospect));
